import axios from 'axios';

const BASE = 'https://mrah.bin-ghanim.com/api';

export const api = {
  getSettings: () => axios.get(`${BASE}/public/settings`),
  getBreeds:   () => axios.get(`${BASE}/public/breeds`),
  listSheep:   (params) => axios.get(`${BASE}/public/sheep`, { params }),
  getSheep:    (id) => axios.get(`${BASE}/public/sheep/${id}`),
  createOrder: (data) => axios.post(`${BASE}/public/orders`, data),
  getOrder:    (id) => axios.get(`${BASE}/public/orders/${id}`),
  getOrdersByPhone: (phone) => axios.get(`${BASE}/public/orders/by-phone/${phone}`),
};

export const getPhotoUrl = (photoUrl) => {
  if (!photoUrl) return null;
  if (photoUrl.startsWith('http')) return photoUrl;
  return `https://mrah.bin-ghanim.com${photoUrl}`;
};
